import {
	Button,
	Col,
	Form,
	InputNumber,
	Row,
	Select,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";

const NewLogisticsRoute = (props) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [clientOptions, setClientOptions] = useState([]);
	const [mineOptions, setMineOptions] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		Promise.all([getClients(), getMines()]).then(() => {
			setLoadingForm(false);
		});
	}, []);

	const getClients = async () => {
		const url = api + "/logistics/client/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setClientOptions(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getMines = async () => {
		const url = api + "/logistics/mine/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setMineOptions(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const createRoute = async (data) => {
		const route = {
			paymentPrice: data.paymentPrice,
			origin: data.origin,
			destination: data.destination,
		};

		try {
			let url = api + "/logistics/route/create";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.post(url, route);

			openNotification("success", "Success", "Route Created");
			setTimeout(() => {
				setLoading(false);
				props.history.push("/logistics/route/list");
			}, 2000);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to create route");
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		createRoute(values);
	};

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Origin"
							name="origin"
							rules={[
								{
									required: true,
									message: "Please select a origin",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select origin`}
								size="large"
								options={mineOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Destination"
							name="destination"
							rules={[
								{
									required: true,
									message: "Please select a destination",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select destination`}
								size="large"
								options={clientOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Payment Price"
							name="paymentPrice"
							rules={[
								{
									required: true,
									message: "Payment Price must be filled",
								},
							]}
						>
							<InputNumber size="large" style={{ width: "100%" }} />
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							size="large"
						>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Layout
			title="Logistics Route"
			description="Create Logistics Route"
			type="medium"
		>
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default NewLogisticsRoute;
